// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"21ef794b","511":"b9e6c308"}[chunkId] + ".chunk.js";
};